import { Text, VStack } from '@chakra-ui/react';

type WaitingHeaderProps = {
  heading: string;
  subline: string;
};

const WaitingHeader = ({ heading, subline }: WaitingHeaderProps) => (
  <VStack spacing={2} maxW="44ch" textAlign="center">
    <Text
      fontSize={{ base: '20px', md: '24px' }}
      fontWeight="700"
      color="leaseEndBlue"
      lineHeight="1.2"
    >
      {heading}
    </Text>
    <Text fontSize={{ base: '13px', md: '14px' }} color="charcoal" lineHeight="1.55">
      {subline}
    </Text>
  </VStack>
);

export default WaitingHeader;
